import React from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Typography, Button } from '@mui/material';
import { HBox } from '@/ui/shared-components/LayoutBoxes';
import theme from "@/theme";
import useTranslation from "@/ui/language/useTranslation";

const QuestionPageBackButton = ({ handleBack }) => {
    const { t } = useTranslation();

    return (
        <HBox>
            <Button
                variant='text'
                sx={{
                    gap: theme.spacing(1),
                    padding: '0',
                    backgroundColor: 'transparent',
                    color: 'pink.main',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: 'black.main',
                    },
                    '&:focus': {
                        backgroundColor: 'transparent',
                        color: 'pink.main',
                    }
                }}
                onClick={handleBack}
            >
                <ArrowBackIcon data-testid="chevron-left-icon" sx={{ fontSize: '16px' }} />
                <Typography variant="body2" sx={{ color: 'inherit' }}>
                    {t('app.nav.previousQuestion')}
                </Typography>
            </Button>
        </HBox>
    )
}

export default QuestionPageBackButton;
